<div class="purchasing-shell">

    <nav class="purchasing-sidebar" [class.collapsed]="collapsed">

        <div class="purchasing-sidebar-header">

            <span class="header-title">Purchasing</span>

            <button type="button" class="collapse-toggle btn btn-link btn-sm p-0" (click)="toggleCollapsed()" [title]="collapsed ? 'Expand sidebar' : 'Collapse sidebar'">

                <fa-icon [icon]="collapsed ? faAnglesRight : faAnglesLeft"></fa-icon>

            </button>

        </div>

        <ul class="purchasing-nav">

            @if (canView(featureType.PurchasingDashboardView)) {

                <li>

                    <a routerLink="dashboard" routerLinkActive="active" title="Dashboard">

                        <fa-icon [icon]="faGauge" class="nav-icon"></fa-icon>

                        <span class="label">Dashboard</span>

                    </a>

                </li>

            }

            @if (canView(featureType.PurchasingQuotingView)) {

                <li>

                    <a routerLink="quoting" routerLinkActive="active" title="Quoting">

                        <fa-icon [icon]="faFileLines" class="nav-icon"></fa-icon>

                        <span class="label">Quoting</span>

                    </a>

                </li>

            }

            @if (canView(featureType.PurchasingPurchaseOrdersView)) {

                <li>

                    <a routerLink="purchase-orders" routerLinkActive="active" title="Purchase Orders">

                        <fa-icon [icon]="faCartShopping" class="nav-icon"></fa-icon>

                        <span class="label">Purchase Orders</span>

                    </a>

                </li>

            }

            @if (canView(featureType.PurchasingReceivingView)) {

                <li>

                    <a routerLink="receiving" routerLinkActive="active" title="Receiving">

                        <fa-icon [icon]="faBoxOpen" class="nav-icon"></fa-icon>

                        <span class="label">Receiving</span>

                    </a>

                </li>

            }

            @if (canView(featureType.PurchasingInvoicingView)) {

                <li>

                    <a routerLink="invoicing" routerLinkActive="active" title="Invoicing">

                        <fa-icon [icon]="faFileInvoiceDollar" class="nav-icon"></fa-icon>

                        <span class="label">Invoicing</span>

                    </a>

                </li>

            }

            @if (canView(featureType.PurchasingReconciliationView)) {

                <li>

                    <a routerLink="reconciliation" routerLinkActive="active" title="Reconciliation">

                        <fa-icon [icon]="faScaleBalanced" class="nav-icon"></fa-icon>

                        <span class="label">Reconciliation</span>

                    </a>

                </li>

            }

        </ul>

    </nav>

    <section class="purchasing-content">

        <router-outlet></router-outlet>

    </section>

</div>


